// extracted by mini-css-extract-plugin
export var content = "Section-module--content--20812";
export var fullWidth = "Section-module--full-width--4f37f";
export var fullWidthInVw = "Section-module--full-width-in-vw--61108";
export var root = "Section-module--root--ed252";